import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class MatchCancelled extends DomainEvent<Match> {}

export class RefreshMatchCancelled extends MatchCancelled {}
